import React, { FC, ReactNode } from 'react';
import { faPen } from '@fortawesome/pro-regular-svg-icons';

import {
  BoxV2 as Box,
  ButtonV2 as Button,
  Flex,
  SxProps,
} from 'portal-commons';

interface SectionProps {
  title: string;
  description?: ReactNode;
  editable?: boolean;
  editDisabled?: boolean;
  onEdit?: () => void;
  sx?: SxProps;
}

const Section: FC<SectionProps> = ({
  title,
  description,
  editable = false,
  editDisabled = false,
  onEdit,
  sx,
  children,
}) => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      ...sx,
    }}
  >
    {(title || editable) && (
      <Flex
        sx={{
          justifyContent: 'flex-start',
          alignItems: 'center',
          width: '100%',
          gap: '8px',
          minHeight: '32px',
        }}
      >
        <Flex sx={{ alignItems: 'center', gap: 'xs' }}>
          {title && (
            <Box
              as="h3"
              sx={{
                fontSize: '18px',
                fontWeight: 600,
                color: 't.black70',
                m: 0,
              }}
            >
              {title}
            </Box>
          )}
        </Flex>
        {editable && (
          <Button
            size="md"
            shape="square"
            variant="transparent"
            color="primary"
            startAdornment={faPen}
            disabled={editDisabled}
            onClick={onEdit}
          >
            Edit
          </Button>
        )}
      </Flex>
    )}
    {description && (
      <Box
        sx={{
          fontSize: '13px',
          color: 't.black60',
          mt: '-4px',
          lineHeight: '20px',
        }}
      >
        {description}
      </Box>
    )}
    {children}
  </Box>
);

export default Section;
